export const GET_HOSTED_WISHLIST = "getHostedWishlist";
export const GET_ARCHIVED_HOSTED_WISHLIST = "getArchivedHostedWishlist";
export const GET_ARCHIVED_PARTICIPATED_WISHLIST = "getArchivedParticipatedWishlist";
export const GET_WISHLIST_DETAIL = "getWishlistDetail";
export const GET_PARTICIPATED_WISHLIST = "getParticipatedWishlist";
export const CREATE_WISHLIST = "createWishlist";
export const DELETE_WISHLIST = "deleteWishlist";
export const UPDATE_WISHLIST = "updateWishlist";
export const ARCHIVE_WISHLIST = "archiveWishlist";
export const UNARCHIVE_WISHLIST = "unArchiveWishlist";
export const UPLOAD_WISHLIST_IMAGE = "uploadWishlistImage";
export const JOIN_WISHLIST_BY_UNIQUECODE = "joinByUniqueCode";
export const STORE_SHARE_EVENTID = "storeEventIdForShare";
export const SHARE_WISHLIST = "shareWishlist";
export const CHECK_PARTICIPANT = "checkParticipant"
export const ACCEPT_REJECT_WISHLIST = "acceptRejectWishlist"
export const GET_REMAINING_EVENTS_COUNT = "getRemainingEventsCount"
export const GET_EVENT_PRICING = "getEventspricing";
export const DELETE_GUEST="deleteGuest";
export const SET_EDITED_WISHLIST = "setEditedWishlist";